<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="650">
      <v-card>
        <v-card-title>
          Создание жилого комплекса
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                text
                x-large
                style="cursor: default;"
                class="btn__icon pa-0 ml-4"
                width="18"
                height="18"
              >
                <v-icon size="x-large">mdi-comment-question-outline</v-icon>
              </v-btn>
            </template>
            <span>Цвет линии и заливки изменять нельзя.</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                text
                x-large
                class="btn__icon pa-0"
                width="18"
                height="18"
                @click="close"
              >
                <v-icon size="x-large">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Закрыть</span>
          </v-tooltip>
        </v-card-title>
        <div class="colors-polygon">
          <div style="flex: 1; text-align: center; opacity: 0.7">
            <label>Цвет линии</label>
            <v-color-picker disabled hide-inputs v-model="polygonOptions.color"></v-color-picker>
          </div>
          <div style="flex: 1; text-align: center; opacity: 0.7">
            <label>Цвет заливки</label>
            <v-color-picker disabled hide-inputs v-model="polygonOptions.fillColor"></v-color-picker>
          </div>
        </div>
        <v-row align="center" class="pa-2" no-gutters>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="name"
              type="string"
              clearable
              outlined
              dense
              hide-details
              label="Название ЖК"
              class="mb-2 mr-2"
            />
          </v-col>
          <v-col cols="12" sm="6">
            <v-file-input
              v-model="logo"
              disabled
              accept=".jpg,.jpeg,.png,.webp"
              label="Загрузите логотип (.jpg, .png, .webp)"
              outlined
              dense
              show-size
              counter
              hide-details
              class="mb-2"
            />
          </v-col>
        </v-row>
        <div style="text-align: right; margin-right: 20px;">
          <v-btn
            style="margin-bottom: 35px"
            color="primary"
            @click="toggleSelection"
          >
            Создать
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
  },
  data () {
    return {
      searchValue: '',
      comment: '',
      name: '',
      menu: false,
      logo: null,
      polygonOptions: {
        color: '#3388ff',
        fillColor: '#3388ff',
        fillOpacity: 0.1,
      },
    };
  },
  methods: {
    toggleSelection () {
      if (this.name === '') {
        this.$flash_danger('Укажите название');
        return;
      }
      this.$emit('toggleSelection', this.name, '', this.logo);
    },
    async close () {
      await this.$emit('close');
      this.name = '';
    },
  },
};
</script>

<style lang="scss">
.color-picker {
  display: flex;
  align-items: center;
  margin-right: 8px;
}

.colors-polygon {
  display: flex;
  align-items: center;
  margin-left: 15px;
}

.color-swatch {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid rgba(0, 0, 0, 0.1);
  margin-right: 8px;
}

@media screen and (max-width: 680px) {
  .colors-polygon {
    display: block;
  }
}
</style>
